import React from 'react'
import PropTypes from 'prop-types'

import UserIconDeprecated from 'core/gd-components/icons/user/user-icon-deprecated'
import ControlButtonStandard from "../../../gd-components/buttons/control-button/control-button-standard"

export default class GDSelectUserValue extends React.Component {

    static propTypes = {
        defaultIcon: PropTypes.string,

        value: PropTypes.string,                // userId

        additionalOptions: PropTypes.array,     // array of objects to add to options, first usage to add "Not assigned" option

        avatarSize: PropTypes.string,           // size of avatr used for renderValue default tiny
        renderValue: PropTypes.oneOf(['name', 'icon-name', 'icon', 'inline', 'form-icon-name', 'form', 'control', 'func']).isRequired, // render value view name
        renderValueFunc: PropTypes.func,        // func for external render function if passed used to render instead of default

        placeholder: PropTypes.string,          // If no value selected string we display

        noValueLabel: PropTypes.string,         // Text that will appear for "no-value" option
        noValueValue: PropTypes.any,         // Text that will appear for "no-value" option

        showPopover: PropTypes.bool,

        onTogglePopover: PropTypes.func
    };

    renderName(user) {
        if (this.props.value && this.props.value !== this.props.noValueValue && user) {
            return <div className="cur-value"><span className="name">{user.name}</span></div>
        } else {
            const label = this.props.value === this.props.noValueValue && this.props.noValueLabel ? this.props.noValueLabel : this.props.placeholder;
            return <div className="cur-value no-val"><span className="name">{label}</span></div>;
        }
    }

    renderIconName(user) {
        if (this.props.value && this.props.value !== this.props.noValueValue && user) {
            return (
                <div className="cur-value">
                    <UserIconDeprecated user={user} hint={false} size={this.props.avatarSize}/>
                    <span className="name">{user.name}</span>
                </div>
            )
        } else {
            const label = this.props.value === this.props.noValueValue && this.props.noValueLabel ? this.props.noValueLabel : this.props.placeholder;
            return <div className="cur-value no-val"><span className="name">{label}</span></div>;
        }
    }

    renderInline(user) {
        if (this.props.value && this.props.value !== this.props.noValueValue && user) {
            return (
                <div className="cur-value">
                    <UserIconDeprecated user={user} hint={false} size={this.props.avatarSize}/>
                </div>
            )
        } else {
            return (
                <div className="cur-value no-val ui5-circle-selector">
                    <div className="icon i5-user"/>
                </div>
            );
        }
    }

    renderForm(user) {
        let valueLabel = this.props.value === this.props.noValueValue && this.props.noValueLabel ? this.props.noValueLabel : this.props.placeholder;
        if (user) valueLabel = user.name;
        return (
            <div className="element-content">
                <span key="label">{valueLabel}</span>
                <div key="arrow" className="arrow-icon i5-big-angle-down" />
            </div>
        );
    }

    renderFormIconName(user) {
        if (this.props.value && this.props.value !== this.props.noValueValue && user) {
            return (
                <div className="cur-value">
                    <UserIconDeprecated user={user} hint={false} size={this.props.avatarSize}/>
                    <span className="name">{user.name}</span>
                    <div className="arrow-icon i5-big-angle-down"/>
                </div>
            )
        } else {
            const label = this.props.value === this.props.noValueValue && this.props.noValueLabel ? this.props.noValueLabel : this.props.placeholder;
            return (
                <div className="cur-value no-val">
                    <span className="name">{label}</span>
                    <div className="arrow-icon i5-big-angle-down"/>
                </div>
            );
        }
    }

    renderControl(user) {

        const defaultIcon = this.props.defaultIcon ? this.props.defaultIcon : "i5-user"

        if (this.props.value && this.props.value !== this.props.noValueValue && user) {
            return (
                <div className="cur-value fl-ac fl-jc s-28">
                    <UserIconDeprecated user={user} hint={false} size={this.props.avatarSize}/>
                </div>
            )
        } else {
            return <ControlButtonStandard className={Classes({'show-popover': this.props.showPopover})}
                                          iconClass={defaultIcon}/>
        }
    }

    renderFunc() {
        return this.props.renderValueFunc(this.props.value);
    }

    render() {
        let res;
        const user = !['func'].includes(this.props.renderValue) ? _.find(this.props.additionalOptions, ao=>ao.id === this.props.value) || gd.session.users.get(this.props.value) : null;

        switch (this.props.renderValue) {
            case 'name'             : res = this.renderName(user); break
            case 'icon-name'        : res = this.renderIconName(user); break

            case 'icon'             :
            case 'inline'           : res = this.renderInline(user); break
            case 'form'             : res = this.renderForm(user); break
            case 'form-icon-name'   : res = this.renderFormIconName(user); break
            case 'control'          : res = this.renderControl(user); break
            case 'func'             : res = this.renderFunc(user); break
        }

        return <div className="value-container pop-target" onClick={this.props.onTogglePopover}>{res}</div>
    };
}
